export default __webpack_public_path__ + "static/mic-checkmate-f83e82a429357e47379fa58f0e79f6da.png";